import React, { useEffect } from "react";
import "./Order_details.css";
import Common_Back_Header from "../../common-components/common_back_header/Common_Back_Header";
import Order_id_holder from "./order_id_holder/Order_id_holder";
import Order_details_table from "./order_details_table/Order_details_table";
import Receiver_info_holder from "./receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "../../common-components/payment_summary/Payment_Summary";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../features/order/orderSlice";
import { useParams } from "react-router-dom";

function Order_details() {
  // const breadcrumbs = [
  //     { label: "Home", link: "/", isActive: false },
  //     { label: "MY ORDERS", link: "/account", isActive: false },
  //     { label: "ORDER DETAILS", link: "", isActive: true },
  // ];

  const { id } = useParams();
  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);

  useEffect(() => {
    dispatch(getOrder({ id: id }));
  }, [dispatch]);
  return (
    <>
      <section className="Order_details">
        <div className="container">
          <Common_Back_Header backNavigation="/my-account" />

          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder
                headingText={`Order ID #${order?.invoice_no}`}
                order={order}
              />
              {order?.Product_Order_Details?.map((val) => (
                <Order_details_table product={val} order={order} />
              ))}
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder showCancelBtn order={order} />

              <Payment_Summary order={order} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Order_details;
